import React from 'react'
import NavBar from '../components/Nav/NavBar'
import CallDetails from '../components/CallDetails/CallDetails'

function Dashboard() {
  return (
    <>
    <NavBar/>
    <CallDetails/>
    </>
  )
}

export default Dashboard